import { render, staticRenderFns } from "./Histogram.vue?vue&type=template&id=971b5460&scoped=true&"
import script from "./Histogram.vue?vue&type=script&lang=js&"
export * from "./Histogram.vue?vue&type=script&lang=js&"
import style0 from "./Histogram.vue?vue&type=style&index=0&id=971b5460&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971b5460",
  null
  
)

export default component.exports